import React from "react"

import { BadgeContainer } from "./course-card-badge.styles"

const CourseCardBadge = ({ badge: { title, color } }) => (
  <BadgeContainer color={color}>{title}</BadgeContainer>
)

export default CourseCardBadge
